import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, getDateRange} from '../../storage'
import {DRN} from './daterange'
import {Currency} from '../../utils/currency'
import {ReducedMonth} from '../../utils/dateformat'
import Select from 'react-select'
import 'react-select/dist/react-select.css';
import {ColumnSummation} from '../../utils/misc'

class ItemSelect extends React.Component {
  constructor(props){
    super(props)
    this.getItems = this.getItems.bind(this)
    this.state = {
      current_item:this.props.item
    }
    this.handleChange = this.handleChange.bind(this)

  }

  handleChange(item) {
    this.props.handleItemChange(item)
    this.setState({current_item: item})
  }

  getItems (input) {
    if (!input) {
      return Promise.resolve({ options: [] });
    }
    return   axios({
        url: '/list_items/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.items}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })
}

  render() {

    let current_item = this.state.current_item
    return <div className="row">
            <div className="col-sm-2">
            <h4>Item</h4>
            </div>
            <div className="col-sm-10">
            <Select.Async name="name" className="" value={current_item} promptTextCreator={this.createItemPromt}
              valueKey="id" labelKey="name" loadOptions={this.getItems} onChange={this.handleChange} autoFocus />
            </div>
    </div>
  }

}

export default class ItemSales extends React.Component {
  constructor() {
    super();
    let dateRange = getDateRange()

    this.state = {
      tableState: {},
      data: [],
      pages: null,
      loading: true,
      dateRange : dateRange
    };
    this.fetchData = this.fetchData.bind(this);
    this.profitFormat =this.profitFormat.bind(this)
    this.invoiceFormat = this.invoiceFormat.bind(this)
    this.applyDateRange = this.applyDateRange.bind(this)
    this.handleItemChange = this.handleItemChange.bind(this)
    document.title = "Item Sales"
  }

  componentDidMount() {
    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.item_id !== "undefined") {
       let item_id = this.props.match.params.item_id
       this.setState({item_id: item_id})
    }
  }

  invoiceFormat(row) {
    let link = "/invoices/edit/"+row.original.invoice.serial
    return <a href={link} target="_blank">Invoice {row.original.invoice.serial}</a>
  }
  profitFormat(row) {

    let quantity=parseFloat(row.original.quantity), selling_rate=parseFloat(row.original.selling_basic_rate), purchase_rate= parseFloat(row.original.purchase_basic_rate)
    let profit = parseFloat((selling_rate-purchase_rate)*quantity).toFixed(2)
    return parseFloat(profit)
  }

  fetchData(state, instance, dateRange=this.state.dateRange, item_id=this.state.item_id) {
    this.setState({ loading: true });
    let apiurl = "/list_item_sales/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id'].toString()
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    if(item_id) {
      apiurl = apiurl + '&item_id='+ item_id
    }
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    this.setState({tableState:state})
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.item_sales,
        item: res.data.item,
        pages: res.data.pages,
        loading: false
      });
    }).catch((err)=>{
      this.setState({loading:false, data:[], pages:null})
    })
  }

  applyDateRange(dateRange){
    this.fetchData(this.state.tableState, {}, dateRange)
  }

  handleItemChange(item){
    this.setState({item_id: item.id})
    this.props.history.push("/reports/item_sale_report/"+item.id)
    this.fetchData(this.state.tableState, {}, this.state.dateRange, item.id)
  }


  render() {
    let purchaseHeader = <span><Currency /> Purchase</span>
    let salesHeader = <span><Currency /> Sales</span>
    let profitHeader =<span><Currency /> Profit</span>
    const { data, pages, loading } = this.state;
    const columns = [
      {Header: 'Month', Cell:(row)=>(ReducedMonth(row.original.month)), sortable:true },
      {Header:'Item Name', accessor: 'name', sortable:true },
      {Header:'Total Items', accessor: 'sales', sortable:true, Cell:(row)=>(<div className="text-right">{row.original.sales}</div>)},
      {Header: purchaseHeader, accessor: 'purchase_amount',
        sortable:true, Cell:(row)=>(<div className="text-right">{row.original.purchase_amount}</div>),
        Footer:<ColumnSummation data={data} sumof='purchase_amount' />
      },
      {Header: salesHeader, accessor: 'sale_amount', sortable:true,
        Cell:(row)=>(<div className="text-right">{row.original.sale_amount}</div>),
        Footer:<ColumnSummation data={data} sumof='sale_amount' />
      },
      {Header: profitHeader, accessor: 'profit',
        Cell:(row)=>(<div className="text-right">{row.original.profit}</div>),
        sortable:true, Footer:<ColumnSummation data={data} sumof="profit" />},

    ]
    let item_id = this.state.item_id
    let table
    if(typeof item_id !== "undefined") {
      table = <ReactTable
        noDataText="No Records Found."
          columns={columns} manual data={data}
          pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
    }

    let itemSelect
    if(typeof this.state.item !== "undefined") {
      itemSelect = <ItemSelect item={this.state.item} handleItemChange={this.handleItemChange}/>
    }


    return <div >
    <section className="medium">
      <div className="row">
        <div className="col-sm-5">
          <h3>Item Sales</h3>
        </div>

        <div className="col-sm-3">
          {itemSelect}
        </div>
        <div className="col-sm-3 col-sm-offset-1">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
        </div>
      </div>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="table-responsive">
          {table}
        </div>
      </div>
    </div>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/report/itemsalesummary.js